import { useIsNarrowPageHeader } from '@buffer-mono/popcorn'

import type { JSX, ReactNode } from 'react'

type NarrowHeaderSlotProps = {
  narrow: boolean
  children: ReactNode
}

export function NarrowHeaderSlot({
  narrow,
  children,
}: NarrowHeaderSlotProps): JSX.Element | null {
  const isNarrowHeader = useIsNarrowPageHeader() ?? false
  return isNarrowHeader === narrow ? <>{children}</> : null
}
